<template lang="pug">
  .avatar
    .wrapper(v-if="user.avatar" @click="onClick")
      img(:src="user.avatar")
    .nickname(v-if="user.nickname" @click="onClick") {{user.nickname}}

</template>

<script>
import gsap from 'gsap'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'HomeAvatar',
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    animeIn(offsets) {
      gsap.fromTo(
        this.$el,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.7,
        }
      )
    },
    onClick() {
      this.setRouterBack('/')
      this.$router.replace('me/main')
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.avatar
  position: absolute
  bottom: 0
  right: pxToRem(40)
  width: pxToRem(84)
  //height: pxToRem(84)
  //background: aquamarine
  opacity: 0
  .wrapper
    line-height: 0
    width: pxToRem(84)
    height: pxToRem(84)
    border-radius: pxToRem(42)
    overflow: hidden
    box-shadow: pxToRem(4) pxToRem(4) pxToRem(11) 0 rgba(0,0,0,0.20), pxToRem(-4) pxToRem(-4) pxToRem(10) 0 #FFFFFF
    img
      width: 100%
      object-fit: contain
  .nickname
    width: 100%
    margin-top: pxToRem(5)
    text-align: center
    font-size: pxToRem(20)
    line-height: pxToRem(28)
    letter-spacing: pxToRem(0.77)
    color: $cl-gray
    font-family: $ff-cn
</style>
